import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkCardContent } from 'uitk-react-cards';

import { SSRRatePlanViewWithReserveButton } from 'components/infosite/rooms-and-rates/rate-plans/internals/ssr-rate-plan-with-reserve-button';
import { Lazy } from 'components/common/lazy/lazy';
import { roomRatePlansWrapperLoadable } from 'components/infosite/rooms-and-rates/loadable';

const RatePlansWrapperLoadable = roomRatePlansWrapperLoadable.codeSplit as any;

export const LazyLoadRatePlans = ({ additionalClass = '', jsEnabled, ratePlanCollection, roomRatesDefaultProps }) => (
  <>
    {!jsEnabled && (
      <UitkCardContent
        className={`l-t-padding-one xl-t-padding-one all-r-padding-one ${additionalClass}`}
        data-stid="js-disabled-rate-plans"
      >
        {ratePlanCollection &&
          ratePlanCollection.map((ratePlan, index) => (
            <ErrorBoundary label="hotel.information.rooms.rateplan.nonhydrated" key={`ratePlan-${index}`}>
              <SSRRatePlanViewWithReserveButton
                {...roomRatesDefaultProps}
                index={index}
                isLastRatePlan={index === ratePlanCollection.length - 1 && ratePlanCollection.length % 2 === 1}
                ratePlan={ratePlan}
              />
            </ErrorBoundary>
          ))}
      </UitkCardContent>
    )}
    {jsEnabled && (
      <Lazy className="uitk-grid uitk-cell" loadOffset={{ top: 350, bottom: 350 }}>
        <Lazy.Placeholder>
          <div data-stid="rate-plans-placeholder" />
        </Lazy.Placeholder>
        <Lazy.Loaded>
          <RatePlansWrapperLoadable {...roomRatesDefaultProps} additionalClass={additionalClass} />
        </Lazy.Loaded>
      </Lazy>
    )}
  </>
);

LazyLoadRatePlans.displayName = 'LazyLoadRatePlans';
